/**
 * @fileoverview `useFeedbackUiTranslate(t)` — the feedback primitives' translator.
 * @package @puffin-core/feedback-ui
 *
 * Resolution order: the consumer's `t` (honoured first) → the `feedbackUi` namespace on the instance
 * in the React tree → `FEEDBACK_UI_EN`, so an unwired tree renders readable English. The primitives
 * call it with no argument: their words arrive as props (a dismiss label, a title) or come from this
 * bundle; a host never passes a translator.
 *
 * `braces: 'single'` + `onMissing: 'keep'`: the bundle carries no placeholder today, and a placeholder
 * whose param did not arrive is echoed back rather than blanking the sentence.
 *
 * ⚠️ Hook-placement rule (RECIPE §3): call this immediately above the first hook or expression that
 * consumes the translator — a custom hook above computed hooks makes `web/component-state-order`
 * report every one of them.
 *
 * @module @puffin-core/feedback-ui/hooks/useFeedbackUiTranslate
 */

import { createInterpolator } from '@puffin-core/i18n-bootstrap/strings-kit';
import { createNamespaceTranslate } from '@puffin-core/i18n-bootstrap/namespace-translate';

import { FEEDBACK_UI_NAMESPACE } from '../strings/namespace.js';
import { resolveString } from '../strings/resolveString.js';

export const useFeedbackUiTranslate = createNamespaceTranslate({
  namespace: FEEDBACK_UI_NAMESPACE,
  resolveString,
  interpolate: createInterpolator({ braces: 'single', onMissing: 'keep' }),
});
